interface SortableByOrder {
    sortOrder: number;
    name: string;
}

export function compareBySortOrderThenName(
    left: SortableByOrder,
    right: SortableByOrder,
): number {
    if (left.sortOrder !== right.sortOrder) {
        return left.sortOrder - right.sortOrder;
    }
    return left.name.localeCompare(right.name);
}
